export default "__VITE_ASSET__0b1c39ed__"